export default __webpack_public_path__ + "static/delivery.url-77946ee9618d66ec43a51877f2231ef7.svg";